<template>
  <div class="is-parent is-vertical box">
    <article>
      <h1 class="title has-text-centered">Shotmap</h1>
      <section id="player_shotmap">
        <section id="global_filters">
          <div class="">
            <div class="columns">
              <div class="column is-4">
                <div class="field is-horizontal">
                  <div class="control">
                    <label class="label">Shot Type</label>
                      <div class="control">
                        <div class="select is-small">
                          <select v-model="ShotTypeSelected" @change="fetchShotmap">
                            <option v-for="option in ShotTypeOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
                          </select>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column is-2">
                <label></label>
                <div class="control">
                  <button class="button is-primary is-small" @click="UseHeatmap = !UseHeatmap; renderHeatmap()">Heatmap</button>
                </div>
              </div>
              <div class="column is-2" v-if="UseHeatmap">
                <label class="label">Blur</label>
                <div class="control">
                  <input class="input is-small" type="number" step="any" placeholder="0.5" v-model="BlurSelected" @change="renderHeatmap">
                </div>
              </div>
              <div class="column is-2" v-if="UseHeatmap">
                <label class="label" >Radius</label>
                <div class="control">
                  <input class="input is-small" type="number" step="any" placeholder="0.5" v-model="RadiusSelected" @change="renderHeatmap">
                </div>
              </div>
              <div class="column is-2">
                <label></label>
                <div class="control">
                  <button class="button is-primary is-small" @click="UseShotZones = !UseShotZones; renderHeatmap()">Shot Zones</button>
                </div>
              </div>
              <div class="column is-2" v-if="UseShotZones">
                <div class="control">
                  <button class="button is-primary is-small" @click="UseShotZonesText = !UseShotZonesText; renderHeatmap()">Toggle Zone Count</button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div class="columns is-vcentered">
          <div class="column">
            <canvas id='home_shotmap' ref="home_shot_canvas" class="is-canvas-responsive shotmap" width="412" height="520"></canvas>
          </div>
        </div>
      </section>
    </article>
  </div>
</template>
<script>
  import simpleheat from '../../store/modules/simpleheat/simpleheat'
  import simpleshot from '../../store/modules/simpleheat/simpleshot'
  import Multiselect from 'vue-multiselect'
  export default {
    props: ['defaultShow', 'home_name', 'away_name'],
    components: {
      'simpleheat': simpleheat,
      'simpleshot': simpleshot,
      Multiselect
    },
    data: function () {
      return {
        show: true,
        gameId: 1,
        SituationOptions: [],
        PeriodOptions: [],
        PeriodSelected: 0,
        SituationSelected: 0,
        HomePlayers: [],
        AwayPlayers: [],
        HomeTeamOptions: [],
        HomeSelection: 0,
        AwayTeamOptions: [],
        AwaySelection: 0,
        ShotTypeSelected: 0,
        ShotTypeOptions: [],
        RadiusSelected: 15,
        BlurSelected: 40,
        UseHeatmap: false,
        UseShotZones: false,
        UseShotZonesText: true,
        HomeMultiSelect: [],
        AwayMultiSelect: []
      }
    },
    computed: {
      sortHomePlayers: function () {
        return this.HomePlayers.slice().sort(function (a, b) {
          return (a.number - b.number)
        })
      },
      sortAwayPlayers: function () {
        return this.AwayPlayers.slice().sort(function (a, b) {
          return (a.number - b.number)
        })
      }
    },
    methods: {
      renderShotZones (canvas, shotData) {
        /*eslint-disable */
        var ctx = canvas.getContext('2d')
        let testColor = 'rgba(250, 1, 1, 0.02)'

        let redZoneColour = 'rgba(250, 1, 1, 0.22)'
        let colour = 'rgba(254, 254, 254, 0.22)'
        let centerPos = [105, 76, 205, 170]

        let outsideZonePos = [0, 360, 590, 140]

        let behindNetPos = [0, 0, 590, 75]

        let leftOutsidePos = [0, 76, 105, 170]

        let rightOutsidePos = [310, 76, 155, 170]

        let leftPointInit = [0, 245]
        let leftPointLines = [{x: 0, y: 245}, {x: 105, y: 245}, {x: 130, y: 360}, {x: 0, y: 360}, {x: 0, y: 0}]

        let centerPointInit = [105, 245]
        let centerPointLines = [{x: 105, y: 245}, {x: 310, y: 245}, {x: 280, y: 360}, {x: 130, y: 360}, {x: 105, y: 245}]

        let rightPointInit = [420, 245]
        let rightPointLines = [{x: 420, y: 245}, {x: 310, y: 245}, {x: 280, y: 360}, {x: 420, y: 360}, {x: 420, y: 370}]

        
        this.drawRect(ctx, colour, outsideZonePos, '12px', 1)
        this.drawRect(ctx, colour, behindNetPos)
        this.drawRect(ctx, colour, leftOutsidePos)
        this.drawRect(ctx, colour, rightOutsidePos)
        this.drawRect(ctx, redZoneColour, centerPos)
        this.drawCustom(ctx, colour, leftPointInit, leftPointLines)
        this.drawCustom(ctx, colour, centerPointInit, centerPointLines)
        this.drawCustom(ctx, colour, rightPointInit, rightPointLines)

        let leftOTCount = 0
        let rightOTCount = 0
        let centerCount = 0
        let behindCount = 0
        let leftPointCount = 0
        let rightPointCount = 0
        let centerPointCount = 0
        let outsideZoneCount = 0
        let redZoneCount = 0
        let behindNetCount = 0
        let totalShots = 0
        console.log(JSON.stringify(shotData))
        for (var shot of shotData) {
          // let s = JSON.parse(shot.shot_location)
          totalShots++
          // Left Outside Count         let leftOutsidePos = [0, 76, 105, 170]
          if (shot[0] >= 0.0 && shot[0] <= 105.0 && shot[1] > 76.0 && shot[1] < 246) {
            // console.log('Shot found: ' + shot[0]  + ' '  + shot[1])
            leftOTCount++
          }
          // Right Outside Count         [310, 76, 155, 170]
          if (shot[0] >= 312 && shot[0] <= 476 && shot[1] > 76.0 && shot[1] < 246) {
             // console.log('Shot found: ' + shot[0]  + ' '  + shot[1])
            rightOTCount++
          }
          // Cneter Count         [105, 76, 205, 170]
          //  this.drawRect(ctx, testColor, [105, 76, 205, 170])
          if (shot[0] >= 105 && shot[0] <= 310 && shot[1] > 76.0 && shot[1] < 246) {
            redZoneCount++
          }
          //{x: 0, y: 245}, {x: 105, y: 245}, {x: 160, y: 360}, {x: 0, y: 360}, {x: 0, y: 370}
          // let leftPointLines = [{x: 0, y: 245}, {x: 105, y: 245}, {x: 130, y: 360}, {x: 0, y: 360}, {x: 0, y: 0}]
          // this.drawCustom(ctx, testColor, leftPointInit, leftPointLines)
          if (shot[0] >= 0 && shot[0] <= 115.0 && shot[1] > 245 && shot[1] < 360) {
            leftPointCount++
          }
          // Right Point  [{x: 420, y: 245}, {x: 310, y: 245}, {x: 280, y: 360}, {x: 420, y: 360}, {x: 420, y: 370}]
          if (shot[0] >= 280 && shot[0] <= 420 && shot[1] > 245 && shot[1] < 360) {
            rightPointCount++
          }
          // Center Point  [{x: 105, y: 245}, {x: 310, y: 245}, {x: 280, y: 360}, {x: 130, y: 360}, {x: 105, y: 245}]
          if (shot[0] >= 116.0 && shot[0] <= 270.0 && shot[1] > 245 && shot[1] < 360) {
            centerPointCount++
          }
          // Outside Zone  [0, 360, 590, 140]
          if (shot[0] >= 0 && shot[0] <= 420 && shot[1] > 360.1 && shot[1] < 590.0) {
            outsideZoneCount++
          }
          // Behind Net  [0, 0, 590, 75]
          if (shot[0] >= 0 && shot[0] <= 420 && shot[1] > 0 && shot[1] < 75.0) {
            behindNetCount++
          }
        }
        if (this.UseShotZonesText) {
          this.drawText(ctx, leftOTCount + ' ' + (leftOTCount / totalShots * 100).toPrecision(2) + '%', [40, 100], '18px')
          this.drawText(ctx, rightOTCount  + ' ' + (rightOTCount / totalShots * 100).toPrecision(2) + '%', [340, 100], '18px')
          this.drawText(ctx, redZoneCount + ' ' + (redZoneCount / totalShots * 100).toPrecision(2) + '%', [180, 95], '18px', 'black')
          this.drawText(ctx, leftPointCount  + ' ' + (leftPointCount / totalShots * 100).toPrecision(2) + '%', [40, 270], '18px')
          this.drawText(ctx, rightPointCount + ' ' + (rightPointCount / totalShots * 100).toPrecision(2) + '%', [340, 270], '18px')
          this.drawText(ctx, centerPointCount + ' ' + (centerPointCount / totalShots * 100).toPrecision(2) + '%', [190, 270], '18px')
          this.drawText(ctx, outsideZoneCount + ' ' + (outsideZoneCount / totalShots * 100).toPrecision(2) + '%', [190, 390], '18px')
          this.drawText(ctx, behindNetCount + ' ' + (behindNetCount / totalShots * 100).toPrecision(2) + '%', [190, 30], '18px')
        }
      },
      drawRect (ctx, color, position, text, textPos, fontSize = '26px', lineWidth = 3) {
        ctx.beginPath()
        ctx.fillStyle = color
        ctx.strokeStyle = '#FFFFFF'
        ctx.shadowOffsetX = ctx.shadowOffsetY = .0;
        ctx.shadowBlur = .2;
        ctx.shadowColor = 'rgb(1, 1, 1)';
        ctx.lineWidth = lineWidth
        ctx.fillRect(position[0], position[1], position[2], position[3])
        ctx.strokeRect(position[0], position[1], position[2], position[3])
        ctx.closePath()
      },
      drawText (ctx, text, textPosition, textSize = '26px', colour='rgba(0,0,0,1)') {
        ctx.beginPath()
        ctx.font = textSize + ' sans-serif'
        ctx.fillStyle = colour
        ctx.fillText(text, textPosition[0], textPosition[1])
        ctx.closePath()
      },
      drawCustom (ctx, color, initPos, movePoints) {
        ctx.beginPath()
        ctx.fillStyle = color
        // ctx.strokeStyle = 'white'
        ctx.moveTo(initPos[0], initPos[1])
        // Loop over move points
        for (var prop of movePoints) {
          ctx.lineTo(prop.x, prop.y)
        }
        ctx.fill()
        ctx.stroke()
        ctx.closePath()
      },
      renderHeatmap () {
        var homeShotsCanvas = this.$refs.home_shot_canvas
        let homeShots = []
        for (var shots of this.PlayerShotmapData) {
          let shot = JSON.parse(shots.shot_location)
          shot[0] = (homeShotsCanvas.width / 600.0) * shot[0]
          shot[1] = (homeShotsCanvas.height / 530.0) * shot[1]
          if (this.UseHeatmap === false) {
            if (shots.shot_type === 'OnNet') {
              shot[4] = 'rgb(180, 8, 8)'
              shot[3] = 5
            } else if (shots.shot_type === 'MissedNet') {
              shot[4] = 'rgba(95, 93, 93)'
              shot[3] = 3
            } else if (shots.shot_type === 'Blocked') {
              shot[4] = 'rgba(20, 23, 81)'
              shot[3] = 3
            } else if (shots.shot_type === 'Goal') {
              shot[4] = 'rgb(31, 239, 0)'
              shot[3] = 6
            } else {
              shot[4] = 'White'
            }
          }
          homeShots.push(shot)
        }
        if (this.UseHeatmap === true) {
          console.log(homeShots)
          var homeHeatmap = simpleheat(homeShotsCanvas).data(homeShots)
          homeHeatmap.radius(this.RadiusSelected, this.BlurSelected)
          homeHeatmap.draw()
        } else {
          homeHeatmap = simpleshot(homeShotsCanvas).data(homeShots)
          homeHeatmap.render()
        }
        if (this.UseShotZones) {
          this.renderShotZones(homeShotsCanvas, homeShots)
        }
      },
      filterPlayers (selectResult) {
        let players = []
        for (var p of selectResult) {
          if (p.id === 0) {
            return 0
          } else {
            players.push(p.id)
          }
        }
        return JSON.stringify(players)
      },
      fetchShotmap () {
        let postData = {
          'situation': 2,
          'player': this.player,
          'team_id': 1,
          'shot_type': this.ShotTypeSelected,
          'year': 2019,
          'competition': 'EIHL_Challenge_Cup'
        }
        console.log('Filter: ' + JSON.stringify(postData))
        this.$http
          .post('https://devilsapi.roblutken.com/api/app/player-stats/shotmap', postData, {
            headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
          })
          .then(
            response => {
              console.log(response.data)
              this.PlayerShotmapData = response.data.player_shots
              this.renderHeatmap()
            },
            response => { }
          )
      },
      fetchFilterOptions () {
        this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
        }).then(
          response => {
            this.SituationOptions.push({ text: 'All', value: 0 })
            this.SituationOptions.push({ text: 'Even Handed', value: 1 })
            this.SituationOptions.push({ text: 'Power Play', value: 2 })
            this.SituationOptions.push({ text: 'Short Handed', value: 3 })
            this.SituationOptions.push({ text: 'Empty Net', value: 4 })

            this.PeriodOptions.push({ text: 'All', value: 0 })
            this.PeriodOptions.push({ text: 'Period 1', value: 1 })
            this.PeriodOptions.push({ text: 'Period 2', value: 2 })
            this.PeriodOptions.push({ text: 'Period 3', value: 3 })
            this.PeriodOptions.push({ text: 'Period OT', value: 4 })
            this.PeriodOptions.push({ text: 'Period Shootout', value: 5 })

            this.ShotTypeOptions.push({ text: 'All', value: 0 })
            this.ShotTypeOptions.push({ text: 'On Net', value: 'OnNet' })
            this.ShotTypeOptions.push({ text: 'Off Target', value: 'MissedNet' })
            this.ShotTypeOptions.push({ text: 'Blocked', value: 'Blocked' })
            this.ShotTypeOptions.push({ text: 'Goal', value: 'Goal' })
          }
        )
      }
    },
    mounted () {
      if (this.defaultShow) {
        this.show = true
      }
      this.player = this.$route.params.player_id
      this.fetchShotmap()
      this.fetchFilterOptions()
    }
  }
</script>
<style>
  .table__wrapper {
    overflow-x: auto;
  }
  .shotmap {
    background: url('~assets/HalfRink.svg');
    background-repeat: no-repeat;
  }
</style>



// WEBPACK FOOTER //
// shots-heatmap-single.vue?e3c89a94